<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5c3.48,0,5.22,1.74,5.22,1.74v7.45l-5.22-3.26l-5.22,3.26v-7.45C-4.72,784.24-2.98,782.5,0.5,782.5L0.5,782.5z
	 M5.72,793.74v3.54L0.5,802.5l-5.22-5.22v-3.54l5.22-3.26L5.72,793.74z"/>
</svg>

</template>